import {
    useHover,
    useFocus,
    useDismiss,
    useRole,
    useInteractions,
    useFloating,
    autoUpdate,
    offset,
    flip,
    shift,
} from '@floating-ui/react';
import {useState} from 'react';
import clsx from "clsx";

export default function IconTooltip({icon, name, size, color, classNames, children, tooltipClassNames, onClick}) {
    const [isOpen, setIsOpen] = useState(false);

    const {x, y, strategy, refs, context} = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        middleware: [offset(10), flip(), shift()],
        whileElementsMounted: autoUpdate,
    });
    const hover = useHover(context, {move: false});
    const focus = useFocus(context);
    const dismiss = useDismiss(context);
    const role = useRole(context, {role: 'tooltip'});

    // Merge all the interactions into prop getters
    const {getReferenceProps, getFloatingProps} = useInteractions([
        hover,
        focus,
        dismiss,
        role,
    ]);
    return (
        <>
            <button ref={refs.setReference} {...getReferenceProps()} aria-label={name} className={`flex ${classNames ? classNames : ''}`} onClick={onClick}>
                {children ? children : <i className={`fa fa-${icon} ${size} ${color}`} aria-hidden="true" />}
            </button>
            {isOpen && (
                <div
                    id={name}
                    className={clsx(`rounded py-1 px-4 text-xs text-brown-300 z-1`, tooltipClassNames)}
                    ref={refs.setFloating}
                    style={{
                        position: strategy,
                        top: y ?? 0,
                        left: x ?? 0,
                        width: 'max-content',
                    }}
                    {...getFloatingProps()}
                >
                    {name}
                </div>
            )}
        </>
    )
}